import styled from 'styled-components';

export const ReviewBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Findings = styled.ul`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  line-height: 1.45;
`;

export const ReviewActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
